const state = {
    offer: {},
    offers: [],
}
const actions = {
    showOffers: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/offers`).then(response => {
                context.commit('SHOW_OFFERS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showOffer: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/offers/${id}`).then(response => {
                context.commit('SHOW_OFFER', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeOffer: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/offers`, payload).then(response => {
                context.dispatch('showOffers')
                context.commit('STORE_OFFER', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateOffer: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/offers/${payload.id}`, payload).then(response => {
                context.dispatch('showOffers')
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyOffer: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/offers/${id}`).then(response => {
                context.dispatch('showOffers')
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_OFFER: (state, payload) => {
        state.offer = payload
    },
    SHOW_OFFERS: (state, payload) => {
        state.offers = payload
    },
    STORE_OFFER: (state, payload) => {
        state.offer = payload
    }
}
const getters = {
    offer: state => {
        return state.offer
    },
    offers: state => {
        return state.offers
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
